import React, { useEffect, useMemo, useState } from "react";
import { Spinner, Tab, Tabs } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import moment from "moment-jalaali";
import MainPanelHeader from "../../../layouts/mainPanelHeader";
import PanelRightContent from "../../../layouts/mainPanel/PanelRightContent";
import { get } from "../../../controlers/global/ConfigRequest";
import { GET_USER_ORDERS } from "../../../helperData/ApiAddress";
import "./style.scss";

const STATUS_KEYS = {
    1: "Organizational.Restaurant.TakingOrder.New.Tab",
    2: "Organizational.Restaurant.TakingOrder.Preparing.Tab",
    3: "Organizational.Restaurant.TakingOrder.Delivery.Tab",
    4: "Organizational.Restaurant.TakingOrder.Closed.Tab",
    5: "UserPanel.Orders.Status.Canceled",
};

function OrdersTable({ orders, loading, emptyKey, t }) {
    if (loading) {
        return (
            <div className="user-panel-empty">
                <Spinner animation="border" />
            </div>
        );
    }
    if (!orders.length) {
        return <div className="user-panel-empty">{t(emptyKey)}</div>;
    }

    return (
        <div className="user-orders-table">
            <div className="user-orders-table__head">
                <div>{t("Organizational.Restaurant.TakingOrder.DetailModal.CodeOrder.Label")}</div>
                <div>{t("UserPanel.Orders.Table.Company")}</div>
                <div>{t("Organizational.Restaurant.TakingOrder.Table.OrderDate")}</div>
                <div>{t("UserPanel.Orders.Table.Total")}</div>
                <div>{t("Organizational.Restaurant.TakingOrder.DetailModal.Status.Label")}</div>
                <div>{t("Organizational.CustomerClub.Members.Metric.Coins")}</div>
            </div>
            {orders.map((order) => (
                <div className="user-orders-table__row" key={order.id}>
                    <div>{order.code || order.id}</div>
                    <div>{order.company?.name || "-"}</div>
                    <div>
                        {order.create_at
                            ? moment(order.create_at).format("jYYYY/jMM/jDD HH:mm")
                            : "-"}
                    </div>
                    <div>
                        {order.total_price != null
                            ? `${Number(order.total_price).toLocaleString("fa-IR")} ${t("Amount.Unit")}`
                            : "-"}
                    </div>
                    <div>{t(STATUS_KEYS[order.status] || STATUS_KEYS[1])}</div>
                    <div>{order.coin || 0}</div>
                </div>
            ))}
        </div>
    );
}

export default function UserOrders() {
    const { t } = useTranslation();
    const [activeTab, setActiveTab] = useState("1");
    const [orders, setOrders] = useState(undefined);

    useEffect(() => {
        get(GET_USER_ORDERS)
            .then((r) => setOrders(Array.isArray(r) ? r : r?.results || []))
            .catch(() => setOrders([]));
    }, []);

    const { openOrders, closedOrders } = useMemo(() => {
        const list = orders || [];
        return {
            openOrders: list.filter((order) => ![4, 5].includes(Number(order.status))),
            closedOrders: list.filter((order) => [4, 5].includes(Number(order.status))),
        };
    }, [orders]);

    return (
        <div id="user-orders" className="main_panel_box user-orders">
            <MainPanelHeader />
            <div className="main_panel_content">
                <PanelRightContent>
                    <div className="tab-section">
                        <Tabs
                            activeKey={activeTab}
                            transition={false}
                            className="panel_tab"
                            onSelect={(key) => setActiveTab(key)}
                        >
                            <Tab
                                eventKey="1"
                                className="panel_tab_item"
                                title={t("UserPanel.Orders.Tab.Open")}
                            >
                                <OrdersTable
                                    orders={openOrders}
                                    loading={orders === undefined}
                                    emptyKey="UserPanel.Orders.Empty.Open"
                                    t={t}
                                />
                            </Tab>
                            <Tab
                                eventKey="2"
                                className="panel_tab_item"
                                title={t("UserPanel.Orders.Tab.History")}
                            >
                                <OrdersTable
                                    orders={closedOrders}
                                    loading={orders === undefined}
                                    emptyKey="UserPanel.Orders.Empty.History"
                                    t={t}
                                />
                            </Tab>
                        </Tabs>
                    </div>
                </PanelRightContent>
            </div>
        </div>
    );
}
